import React from 'react';
import { Header, List } from '../Index';

const Index = () => {
  return (
    <div>
      <Header />
      <section style={{ marginTop: '8rem' }}>
        <List />
      </section>
    </div>
  );
};

export default Index;
